<div class="notification-bell-wrapper">
  <div class="notification-bell" (click)="toggleDropdown()">
    <button class="bell-button" [class.has-unread]="(unreadCount$ | async)! > 0">
      <svg class="bell-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>

      <span *ngIf="(unreadCount$ | async)! > 0" class="badge">
        {{ (unreadCount$ | async)! > 99 ? '99+' : (unreadCount$ | async) }}
      </span>
    </button>

    <!-- Connection Status Indicator -->
    <div class="connection-indicator" [class]="connectionStatusClass">
      <div class="pulse"></div>
    </div>
  </div>

  <!-- Dropdown -->
  <div *ngIf="isDropdownOpen" class="notification-dropdown">
    <app-notification-list (click)="$event.stopPropagation()"></app-notification-list>
  </div>

  <!-- Overlay pour fermer le dropdown -->
  <div *ngIf="isDropdownOpen" class="notification-overlay" (click)="closeDropdown()"></div>
</div>
